import 'bootstrap/dist/css/bootstrap.min.css';
import 'datatables.net';
import 'datatables.net-buttons';
import 'datatables.net-buttons-dt/css/buttons.dataTables.min.css';
import 'datatables.net-buttons/js/buttons.colVis';
import 'datatables.net-buttons/js/buttons.html5';
import 'datatables.net-buttons/js/buttons.print';
import $ from 'jquery';
import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { baseurl } from '../utility/helper';

const TestimonialList = () => {
  const [newsEvents, setNewsEvents] = useState([]);
  const tableRef = useRef(null);

  // Fetch news events from the API
  useEffect(() => {
    const fetchNewsEvents = async () => {
      try {
        const token = sessionStorage.getItem("token"); // or sessionStorage, or from state/context
        const response = await fetch(`${baseurl}/admin/eventlist`, {
          method: 'GET',
          headers: {
            'Authorization': `${token}`, // Ensure token is sent
            'Content-Type': 'application/json'
          }
        });

        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const data = await response.json();
        setNewsEvents(data);
      } catch (error) {
        console.error('Error fetching news events:', error);
      }
    };

    fetchNewsEvents();
  }, []);

  // Initialize the DataTable after news events are fetched
  useEffect(() => {
    if (tableRef.current && newsEvents.length > 0) {
      const table = $(tableRef.current);
      if (!table.hasClass('dataTable')) {
        table.DataTable({
          dom: 'Bfrtip',
          buttons: [
            {
              extend: 'copyHtml5',
              className: 'btn btn-primary dttable',
              exportOptions: {
                columns: ':visible',
              },
            },
            {
              extend: 'excelHtml5',
              className: 'btn btn-primary dttable',
              exportOptions: {
                columns: ':visible',
              },
            },
            {
              extend: 'csvHtml5',
              className: 'btn btn-primary dttable',
              exportOptions: {
                columns: ':visible',
              },
            },
            {
              extend: 'pdfHtml5',
              className: 'btn btn-primary dttable',
              exportOptions: {
                columns: ':visible',
              },
            },
            {
              extend: 'print',
              className: 'btn btn-primary dttable',
              exportOptions: {
                columns: ':visible',
              },
            },
            {
              extend: 'colvis',
              className: 'btn btn-primary dttable',
              exportOptions: {
                columns: ':visible',
              },
            },

          ],
        });
      }
    }
  }, [newsEvents]);

  const handleDelete = (id) => {
    const token = sessionStorage.getItem("token"); // Retrieve token from local storage (or another storage method)

    fetch(`${baseurl}/admin/eventlist/${id}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `${token}`, // Pass the token in the Authorization header
        'Content-Type': 'application/json' // Ensure proper content type
      }
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to delete event');
        }
        return response.json();
      })
      .then(() => setNewsEvents(newsEvents.filter((event) => event.id !== id)))
      .catch((error) => console.error('Error deleting event:', error));
  };


  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');  // Ensures day is 2 digits (e.g., '01', '02')
    const month = String(date.getMonth() + 1).padStart(2, '0');  // Month is 0-based, so add 1
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;  // Format: dd-mm-yyyy
  };

  return (
    // <div className="page-wrapper">
    <div className="container mt-4 ">
      <div className="card p-4 shadow">
        <center><h2 className="mb-4">Testimonial List</h2></center>

        <br></br>
        <div className="table-responsive">
          <table ref={tableRef} className="table table-striped table-bordered">
            <thead className="thead-dark">
              <tr>
                <th>Name</th>
                <th>Mobile No</th>
                <th>Email</th>
                <th>Message</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {newsEvents.map((event) => (
                <tr key={event.id}>
                  <td>Test</td>
                  <td>9988778899</td>
                  <td>Test@csismtechnologies.com</td>
                  <td style={{ textWrap: 'auto' }}>
                    <span>The fact that Mensa provides a forum to the intelligentia to exchange views on diverse issues makes it a unique organisation.</span></td>
                  <td>
                    <Link to={`/admin/Newsevent/${event.id}/edit`} className="btn btn-warning btn-sm me-2">
                      Visible
                    </Link>
                    {/* <button
                      onClick={() => handleDelete(event.id)}
                      className="btn btn-danger btn-sm"
                    >
                      Delete
                    </button> */}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
    // </div>
  );
};

export default TestimonialList;
